import reducer from './slice';

export default reducer;

export * from './slice';
export * from './selectors';

export { fetchAgreements } from './thunks/fetchAgreements';
